import { Component, Input } from '@angular/core';

import { InvoiceState } from '@jessie/commons';

@Component({
  selector: 'app-invoice-state-badge',
  templateUrl: './invoice-state-badge.component.html',
  imports: [],
  styles: `
    @reference "tailwindcss";
    :host {
      @apply contents;
    }
  `,
})
export class InvoiceStateBadgeComponent {
  @Input()
  invoiceState!: InvoiceState;
}
